<template>
<div class="pl-0 py-1 d-flex text-capitalize">
  <div v-if="typeof option === 'object'" :class="option[itemClass]">
    <img v-if="option.type && option.type == 'View::List'" class="mr-2" src="../../assets/images/icons/c_list_green.svg">
    <img v-if="option.type && option.type == 'View::Board'" class="mr-2" src="../../assets/images/icons/c_board_orange.svg">
    <img v-if="option.type && option.type == 'View::Calendar'" class="mr-2" src="../../assets/images/icons/c_calendar_purple.svg">
    <v-icon v-if="option.type && option.type == 'Analytic::Finance'" class="mr-2 mb-1" dense color="rgba(51, 51, 51, 1)">mdi-database-outline</v-icon>
    <v-icon v-if="option.type && option.type == 'Analytic::Case'" class="mr-2 mb-1" dense color="rgba(51, 51, 51, 1)">mdi-dresser-outline</v-icon>
    <v-icon v-if="option.type && option.type == 'Analytic::Task'" class="mr-2 mb-1" dense color="rgba(51, 51, 51, 1)">mdi-book-open-outline</v-icon>
    <v-icon v-if="option.type && option.type == 'Analytic::Invoice'" class="mr-2 mb-1" dense color="rgba(51, 51, 51, 1)">mdi-receipt</v-icon>
    <v-icon v-if="option.type && option.type == 'Analytic::Payment'" class="mr-2 mb-1" dense color="rgba(51, 51, 51, 1)">mdi-currency-usd</v-icon>
    {{ option[itemText] }} <span v-if="itemDescription"> - {{ option[itemDescription] }}</span>
  </div>
  <div v-else :class="option[itemClass]">{{ option }}</div>
  <v-spacer></v-spacer>
  <CMenu v-if="addsFunction && anotherAddsFunction && option['default'] == false" class="mr-2 expansion-menu">
    <template v-slot:button>
      <p class="mb-0"><img src="../../assets/images/icons/three-dot-horizontal.svg"></p>
    </template>
    <template v-slot:dropdown-item>
      <div @click.stop="anotherAddsFunction(option)" class="pl-0" :class="anotherAddsClass" style="cursor: pointer;">Rename</div>
      <div @click.stop="addsFunction(option)" class="pl-0" style="cursor: pointer; color: #EB5757;">Delete</div>
    </template>
  </CMenu>
</div>
</template>
<script>
import CMenu from './c-menu'
export default {
  props: {
    anotherAddsFunction: {
      type: Function
    },
    addsFunction: {
      type: Function
    },
    option: {
      type: [Object, String]
    },
    itemText: {
      type: String
    },
    itemDescription: {
      type: String,
      default: ''
    },
    itemClass: {
      type: String,
      default: ''
    },
    anotherAddsClass: {
      type: String,
      default: ''
    }
  },
  components: {
    CMenu
  }
}
</script>